import { Component, OnInit, Output, EventEmitter, Input, HostListener, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';
import { Select2Directive } from "@teem/directives/select2.directive";
import { messages as i18n } from '@teem/constants/messages';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RejectionReasonComponent } from '../modals/rejection-reason/rejection-reason.component';
import { OrderHistoryComponent } from '../modals/order-history/order-history.component';
import { OrderOtoComponent } from '../modals/order-oto/order-oto.component';
import { OrderService } from '@teem/app/core/services/order.service';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { Clipboard } from '@angular/cdk/clipboard';
declare var $;
@Component({
  selector: 'new-order-list',
  templateUrl: './new-order-list.component.html',
  styleUrls: ['./new-order-list.component.scss']
})
export class NewOrderListComponent implements OnInit {
	@Output() onPageChange: EventEmitter<any> = new EventEmitter();
	@Output() onViewOrder: EventEmitter<any> = new EventEmitter();
	@Input() orders;
	@Input() paginator;
  @Output() perPageItems: EventEmitter<any> = new EventEmitter();
  @Output() orderAction: EventEmitter<any> = new EventEmitter();
  @Output() updateOrderStatuses: EventEmitter<any> = new EventEmitter();
  @Output() sortRequested = new EventEmitter<{ column: string; direction: string }>();
  itemsPerPageOptions = [10, 20, 50, 100];
  sortColumn: string | null = null;
  sortDirection: 'asc' | 'desc' = 'asc';

  constructor(
    private modalService: NgbModal,
    private elem: ElementRef,
    private orderService: OrderService,
    private loaderService: LoaderService,
    private clipboard: Clipboard
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 100);
  }
  // Emit event to parent to fetch orders with sorting
  sortData(column: string) {
    // Toggle sort direction if the same column is clicked
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // New column clicked, reset to ascending
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    // Emit event to the parent component to call the API
    this.sortRequested.emit({ column: column, direction: this.sortDirection });
  }

  @HostListener('document:click', ['$event'])
  DocumentClick(event: Event) {
    if (!this.elem.nativeElement.contains(event.target)){
      $(".options-menu").addClass('d-none');
    }
  }

  toggleOrderDetails(number:any) {
    $('#catalogue-details-'+number).slideToggle();
  }

  onChangeItemsPerPage(event: Event, api: any) {
    console.log('child')
    const selectElement = event.target as HTMLSelectElement;
    this.perPageItems.emit({ limit: +selectElement.value });
  }

  updateOrderStatus(action, uuid) {
    Swal.fire({
      icon:'info',
      title: i18n.are_you_sure,
      text: i18n.order.you_want_update_status,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: '#ee3a7a',
      confirmButtonText:
      i18n.order.update_status,
      cancelButtonText:
        i18n.cancel
    }).then(result => {
      if (result.value) {
        this.updateOrderStatuses.emit({ uuid: uuid, action: action });
      }
    });
  }

  orderActions(action, uuid, from = null) {
    switch (action) {
      case "resend_invoice":
        this.orderAction.emit({ uuid: uuid, action: action });
        break;
      case "accept":
        Swal.fire({
          title: i18n.are_you_sure_want_accept_order,
          icon: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#ee3a7a',
          confirmButtonText:
            i18n.accept_order,
          cancelButtonText:
            i18n.cancel
        }).then(result => {
          if (result.value) {
            this.orderAction.emit({ uuid: uuid, action: action, from:from });
          }
        });
        break;
      case "delete":
          Swal.fire({
            icon: 'info',
            title: i18n.order.are_you_sure_want_delete_order,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#ee3a7a',
            confirmButtonText:
              i18n.order.delete_order,
            cancelButtonText:
              i18n.cancel
          }).then(result => {
            if (result.value) {
              this.orderAction.emit({ uuid: uuid, action: action });
            }
          });
          break;
      case "cancel":
        Swal.fire({
          title: i18n.order.are_you_sure_want_cancel_order,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#ee3a7a',
          confirmButtonText:
            i18n.order.cancel_order,
          cancelButtonText:
            i18n.cancel
        }).then(result => {
          if (result.value) {
            this.orderAction.emit({ uuid: uuid, action: action });
          }
        });
        break;
      case "rejected":
        const modalRef = this.modalService.open(RejectionReasonComponent);
        console.log(modalRef.componentInstance)
        modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "rejection-modal";
        modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.classList.add("quotation-modal");
        modalRef.componentInstance.orderAction = this.orderAction;
        modalRef.componentInstance.orderStatus = 'rejected';
        modalRef.componentInstance.orderUuid = uuid;
        modalRef.componentInstance.orderFrom = from;
        modalRef.result.then(data => {

        }, fallbackResult => {

        })
        break;
      case "declined":
        const modaldeclined = this.modalService.open(RejectionReasonComponent);
        modaldeclined.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "rejection-modal";
        modaldeclined.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.classList.add("quotation-modal");
        modaldeclined.componentInstance.orderAction = this.orderAction;
        modaldeclined.componentInstance.orderStatus = 'declined';
        modaldeclined.componentInstance.orderUuid = uuid;
        modaldeclined.componentInstance.orderFrom = from;
        modaldeclined.result.then(data => {

        }, fallbackResult => {

        })
        break;
      case "request_declined":
        const modalRefDeclined = this.modalService.open(RejectionReasonComponent);
        console.log(modalRefDeclined.componentInstance)
        modalRefDeclined.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "rejection-modal";
        modalRefDeclined.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.classList.add("quotation-modal");
        modalRefDeclined.componentInstance.orderAction = this.orderAction;
        modalRefDeclined.componentInstance.orderStatus = 'request_declined';
        modalRefDeclined.componentInstance.orderUuid = uuid;
        modalRefDeclined.result.then(data => {

        }, fallbackResult => {

        })
        break;
      case "create_logistiq":
        Swal.fire({
          title: 'Create order with logistiq partner?',
          icon: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#ee3a7a',
          confirmButtonText:
            i18n.yes,
          cancelButtonText:
            i18n.cancel
        }).then(result => {
          if (result.value) {
            this.orderAction.emit({ uuid: uuid, action: action });
          }
        });
        break;
      case "change_priority":
        this.orderAction.emit({ uuid: uuid, action: action });
        break;
    }
  }

  orderHistory(action, uuid) {
    this.loaderService.startLoading();
    this.orderService.getStatuses(uuid).subscribe(data => {
      this.loaderService.stopLoading();
      const orderModalRef = this.modalService.open(OrderHistoryComponent);
      orderModalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "order-history-modal";
      orderModalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.classList.add("orderhistory-modal");
      orderModalRef.componentInstance.order = data;
      orderModalRef.result.then(data => {

      }, fallbackResult => {

      })
    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    });
  }

  orderWithOto(uuid) {
    this.loaderService.startLoading();
    this.orderService.getOrder(uuid).subscribe(data => {
      this.loaderService.stopLoading();

      const orderModalRef = this.modalService.open(OrderOtoComponent);
      orderModalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "recordpayment";
      // orderModalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "order-history-modal";
      // orderModalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.classList.add("orderhistory-modal");
      orderModalRef.componentInstance.order = data;
      orderModalRef.result.then(data => {
        if (data) {
          window.location.reload();
        }
      }, fallbackResult => {

      })
    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    });
  }

  orderShipmentWithOto(uuid) {
    Swal.fire({
      text: 'Create order shipment on OTO',
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: '#ee3a7a',
      confirmButtonText:
        i18n.yes,
      cancelButtonText:
        i18n.cancel
    }).then(result => {
      if (result.value) {
        this.loaderService.startLoading();
        this.orderService.createShipmentOnOto(uuid).subscribe((data: any) => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.done, data.message, 'success');
        }, err => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      }
    });
  }

  copyAddress(order: any) {
    try {
      let fullAddress = order.full_address;
      let latitude = order.location.latitude;
      let longitude = order.location.longitude;
      let location = "https://maps.google.com/maps?q="+latitude+","+longitude;
      let copyDate = i18n.order.order_number+" : "+order.order_number+"\n"+i18n.order.customer_info+" : "+order.client_name+" "+order.client_phone+"\n"+i18n.order.delivery_info+" : "+order.full_address+"\n"+i18n.order.location+" : "+location;
      if (order.attachment) {
        copyDate += "\n"+i18n.order.location_attachment+" : "+order.attachment;
      }
      this.clipboard.copy(copyDate);
      Swal.fire(i18n.done, i18n.order.address_copied_to_clipboard, 'success');
    } catch (err) {
      console.error(err);
    }
  }

  toggleDropdownMenu(index) {
    const $menu = $("#options-menu-" + index);

    // Hide all other menus
    $(".options-menu").not($menu).addClass('d-none');

    // Check if this menu has child elements
    if ($menu.children().length === 0) {
        // No hierarchy → always keep hidden
        $menu.addClass('d-none');
        return;
    }

    // Toggle only if it has children
    $menu.toggleClass('d-none');

    // $(".options-menu").not("#options-menu-"+index).addClass('d-none');
    // $("#options-menu-"+index).toggleClass('d-none');
    // $("#tm-dropdown__menu-"+index).fadeOut();
    // $(".catalogue-table__colCenter").css("z-index", "0");
    // // e.stopPropagation();
    // $('#tm-dropdown__btn-'+index).next().fadeToggle(100);
    // $('#tm-dropdown__btn-'+index).parent().parent().css("z-index", "1111");
  }

  toggleStatusDropdownMenu(index) {
    $("#tm-status_dropdown__menu-"+index).fadeToggle();
    $(".catalogue-table__col--column").css("z-index", "0");
    // e.stopPropagation();
    // $('#tm-status_dropdown__btn-'+index).next().fadeToggle(100);
    $('#tm-status_dropdown__btn-'+index).parent().parent().css("z-index", "11111");
  }

  toggleMenu(e) {
    $(".dropdown__menu_action").fadeOut();
    $(".catalogue-table__colCenter").css("z-index", "0");
    e.stopPropagation();
    $('.dropdown__btn_action').next().fadeToggle(100);
    $('.dropdown__btn_action').parent().parent().css("z-index", "1111");
  }

  toggleStatusMenu(index) {
    $(".status-dropdown-menu").not("#status-dropdown-menu-"+index).hide();
    $("#status-dropdown-menu-"+index).fadeToggle();
  }

  transStatus(status : string) {
    return i18n.t(status.toLowerCase());
  }

  checkStatusForRefund(orderUuid : string){
    this.loaderService.startLoading();
    this.orderService.checkStatusForRefund(orderUuid).subscribe((data: any) => {
      this.loaderService.stopLoading();
      Swal.fire({
        title: i18n.are_you_sure,
        text: data.message,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: '#ee3a7a',
        confirmButtonText: i18n.yes,
        cancelButtonText: i18n.cancel
      }).then(result => {
        if (result.value) {
          this.loaderService.startLoading();
          this.orderService.initiateRefund(orderUuid,data.data).subscribe((data: any) => {
            this.loaderService.stopLoading();
            this.sortData('created_at');
            Swal.fire(i18n.done, data.message, 'success');
          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          })
        }
      });
    }, err => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    })
  }
}
